"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayersvoteGames = void 0;
var game_1 = require("../models/game");
var game_source_1 = require("../models/game_source");
var PlayersvoteGames;
(function (PlayersvoteGames) {
    PlayersvoteGames.RATING_NUMBERS = [1, 2, 3, 4, 5, 6];
    function isGameHighScoringGame(game) {
        return game.sport_type === game_1.SportType.Basketball;
    }
    PlayersvoteGames.isGameHighScoringGame = isGameHighScoringGame;
    function getMainTeamForGameSource(game, gameSource) {
        if (gameSource.type === game_source_1.GameSourceType.TEAM) {
            if (gameSource.team_opta_id === game.team_1.opta_id) {
                return game.team_1;
            }
            else if (gameSource.team_opta_id === game.team_2.opta_id) {
                return game.team_2;
            }
        }
        return null;
    }
    PlayersvoteGames.getMainTeamForGameSource = getMainTeamForGameSource;
    function getDisplayTextForRatingNumber(number, gameSource) {
        if (gameSource.reversed_rating_scale) {
            return 7 - number;
        }
        return number;
    }
    PlayersvoteGames.getDisplayTextForRatingNumber = getDisplayTextForRatingNumber;
})(PlayersvoteGames = exports.PlayersvoteGames || (exports.PlayersvoteGames = {}));
